import React from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { Container } from "semantic-ui-react";
// import "./App.css";
import MenuBar from "./components/layout/MenuBar";
import PrivateRoute from "./components/routes/PrivateRoute";
import ModeSwitch from "./components/layout/ModeSwitch";
import { LoginForm } from "./components/forms";
import { LoaderWithDelay } from "./components/helpers";
import Dashboard from "./components/pages/Dashboard";
import ProjectPage from "./components/pages/ProjectPage";
import RecordingPage from "./components/pages/RecordingPage";
import NotFound from "./components/pages/NotFound";
import Notifier from "./components/notifications/Notifier";

const App = () => {
  const authenticating = useSelector((state) => state.auth.loading);
  const isAuthenticated = useSelector((state) => !!state.auth.isAuthenticated);
  return (
    <>
      <MenuBar />
      {authenticating && <LoaderWithDelay size="massive" active />}
      {!authenticating && (
        <>
          <Container>
            <Notifier />
            {isAuthenticated && <ModeSwitch />}
            <Switch>
              <PrivateRoute exact path="/" component={Dashboard} />
              <PrivateRoute
                exact
                path="/:ownerName/:projectSlug"
                component={ProjectPage}
              />
              <PrivateRoute
                exact
                path="/:ownerName/:projectSlug/recording/:recNum?"
                component={RecordingPage}
              />
              <Route exact path="/login" component={LoginForm} />
              <Route component={NotFound} />
            </Switch>
          </Container>
        </>
      )}
    </>
  );
};

export default App;
